import {Component, OnInit, ChangeDetectionStrategy, Inject, Input, AfterViewChecked, Output, EventEmitter, ViewChild} from '@angular/core';
import {SWIPER_CONFIG, SwiperConfigInterface} from 'ngx-swiper-wrapper';

@Component({
    selector: 'app-swiper',
    templateUrl: './swiper.component.html',
    styleUrls: ['./swiper.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SwiperComponent implements OnInit, AfterViewChecked {
    @Input() config: SwiperConfigInterface;
    @Input() slideIndex = 0;
    @Input() class: string;

    @Output() indexChange: EventEmitter<number> = new EventEmitter();

    constructor(@Inject(SWIPER_CONFIG) private readonly swiperConfig: SwiperConfigInterface) {
    }

    ngOnInit() {
        if (!this.config) {
            this.config = Object.assign({}, this.swiperConfig, {
                slidesPerView: 1.3
            });
        } else {
            this.config = Object.assign({}, this.config);
        }
    }

    ngAfterViewChecked() {
        window.dispatchEvent(new Event('resize'));
    }

    onIndexChange(index: number) {
        this.indexChange.next(index);
    }
}
